export default `
query QueryWebClosetProducts($filters: ProductFilters, $search_context: ProductSearchContextInput , $in_closet:Boolean , $in_perfect_closet : Boolean) {
  products(filters: $filters, search_context: $search_context, in_closet: $in_closet , in_perfect_closet:$in_perfect_closet) {
    id
    type
    state
    disabled
    swappable
    brand {
      name
    }
    title
    tote_slot
    season_sample
    activated_at
    rent_warn
    catalogue_photos(limit: 1) {
      medium_url
      full_url
    }
    category {
      name
      accessory
    }
    member_price
    sale_price
    full_price
  }
}

`
